// eslint-disable-next-line import/prefer-default-export
export const isPDP = () => /^(\/ca)?\/[\w-]+\.html$/.test(window.location.pathname);
export const isPLP = () =>
  /^\/(ca\/?)?$/.test(window.location.pathname) && window.location.search.length > 0;
export const isCartPage = () => /^(\/ca)?\/cart\/buy\/?$/.test(window.location.pathname);
export const isHomePage = () =>
  /^(\/ca)?\/$/.test(window.location.pathname) && window.location.search.length === 0;
export const isCheckoutPage = () => /^(\/ca)?\/checkout\/?$/.test(window.location.pathname);
// Legacy order-confirmation / thank-you page. The server-rendered URL is
// `/checkout/thankyou` (see common/payment/accelerated-payment-navigation.js and
// the react-cart store), so we anchor on that exact path rather than the bare
// `/checkout` that isCheckoutPage matches.
export const isCheckoutThankYouPage = () =>
  /^(\/ca)?\/checkout\/thankyou\/?$/.test(window.location.pathname);
// Prefix-matching purchase-flow predicates. Unlike the strict isCartPage /
// isCheckoutPage above (which getPageName uses for exact analytics page names),
// these match every step of the legacy purchase flow:
//   - the canonical cart `/cart` AND `/cart/buy` (both render spree/orders#edit)
//   - bare `/checkout` AND the multi-step `/checkout/:state` (address, delivery,
//     payment, confirm) plus the payment-return GETs (`/checkout/paypal/confirm`,
//     `/checkout/venmo/confirm`, `/checkout/klarna/confirm`, ...)
// A mobile-app session sits ON these inner routes (bare `/checkout` redirects
// into the first state), so the guard below must cover them or the auto-reload
// still fires mid-purchase — exactly what MN-8242 set out to prevent. The
// `(\/|$)` boundary matches the trailing slash or end-of-path without matching
// an unrelated sibling like `/checkoutXYZ`.
export const isCartFlowPage = () => /^(\/ca)?\/cart(\/|$)/.test(window.location.pathname);
export const isCheckoutFlowPage = () => /^(\/ca)?\/checkout(\/|$)/.test(window.location.pathname);
// True on any purchase-critical legacy route (cart, checkout flow, thank-you /
// order-confirmation). Composed from the prefix predicates above so callers that
// must not disrupt an in-flight purchase (e.g. the mobile-app auto-reload timer,
// MN-8242) can guard with a single check and stay in sync if those route shapes
// change. isCheckoutThankYouPage is already subsumed by isCheckoutFlowPage, but
// is kept explicit so the thank-you guard survives any future narrowing of the
// checkout prefix.
export const isPurchaseCriticalPage = () =>
  isCartFlowPage() || isCheckoutFlowPage() || isCheckoutThankYouPage();
// eslint-disable-next-line consistent-return
export const getPageName = () => {
  if (isPDP()) return "pdp";
  if (isPLP()) return "plp";
  if (isHomePage()) return "home";
  if (isCartPage()) return "cart";
  if (isCheckoutPage()) return "checkout";
};
